
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from "@angular/router";


import * as Objects from '@core/objects';
import { VersionShare, UploadVersionShare, UploadVersionStatusCodeEnum } from '@core/models/version-share.model';

@Component({
    selector: 'core-versions-upload-version-box',
    templateUrl: './upload-version-box.component.html',
    styleUrls: ['./upload-version-box.component.scss']
})
export class VersionsUploadVersionBoxComponent implements OnInit, OnChanges {
    public readonly UPLOAD_STATUS = UploadVersionStatusCodeEnum;

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly NOT_FOUND = 2;
    public readonly SHARE_ERROR = 3;
    
    @Input() versionShare: VersionShare = null;
    // @Input() uploadVersion: UploadVersionShare;
    @Input() actionButton: boolean = true;

    @Input() project: Objects.Request = null;
    @Input() version: Objects.Version = null;

    //TODO maybe an output to click buutton to router in the parent.

    public message: string = '';
    public status: number = this.LOADING;
    public shareLoaded: boolean = false;

    constructor(private router: Router, private httpClient:HttpClient ){}

    ngOnInit(): void {
        if(this.versionShare?.entry && this.versionShare?.entry.token != ''){

            this.shareLoaded = false;
            this.loadShareRequest();
        } else {
            this.status = this.SHARE_ERROR;
        }       
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.versionShare){
            this.status = this.LOADING;
            // console.debug(" CHANGES versionShare  ---> ", changes.versionShare);
            this.initView();
        }
    }

    onOpenUpload() : void {
        if(!this.actionButton)
            return;
        let url = "/upload";
        if(this.version != null)
            url = "/versions/"+this.version.id + "/upload";
        
        if(this.version != null && this.project != null)
            url = "/projects/"+this.project.id +"/versions/"+this.version.id + "/upload";

        this.router.navigate([url]);

    }

    private loadShareRequest(){
        this.httpClient.get('/web/share/upload-version/'+this.versionShare.entry.token).subscribe({
            next: (data: any) => {
                // console.debug(" SHARE ENTRY IS ---> ", data);
                this.message = data.properties.email_content;
                // this.setRequest(data);
                this.shareLoaded = true;
                this.initView();
            },
            error: (error:any) => {
                this.status = this.NOT_FOUND;
                console.debug(" SHARE ENTRY ERRORRR ", error);
            }
        });
    }

    initView(){
        if(this.versionShare != null && this.shareLoaded){
            this.status = this.DONE;
        }
    }


}